/**
 * Organization Roles — resource-scoped runtime hooks.
 */
import { ADMIN_RESOURCE_REGISTRY, type OperationId, type RouteId } from '@finance/contracts';
import { useOrganizationRolesList as useOrganizationRolesListQuery, type RoleSurfaceDto } from '../../../api/generated/client';
import { useRole } from '../../admin/admin-resource-hooks.js';
import { selectApiData, type ApiSuccessEnvelope } from '../../../api/select-api-data.js';
import type { ListHookResult, GetHookResult, ResourceHookBinding } from '../../resource-hook-registry.js';

const contract = ADMIN_RESOURCE_REGISTRY['organization-roles'];

function selectRoleListRows(response: unknown): RoleSurfaceDto[] {
  const dto = selectApiData(response as ApiSuccessEnvelope<{ data: { table: { rows: RoleSurfaceDto[] } } }>);
  return dto.data.table.rows;
}

function useRoleList(): ListHookResult<RoleSurfaceDto[]> {
  return useOrganizationRolesListQuery(undefined, { query: { select: selectRoleListRows } });
}

export const ORGANIZATION_ROLES_HOOKS: ResourceHookBinding = {
  useList: useRoleList,
  selectList: selectRoleListRows,
  useGet: (id: string) => useRole(id) as unknown as GetHookResult<unknown>,
  selectDetail: (data) => data,
  rowIdExtractor: (row: Record<string, unknown>) => (typeof row.id === 'string' ? row.id : undefined),
  rowIdField: 'id',
  routeParameterName: 'roleId',
  paramName: 'roleId',
  listRouteId: contract.listRouteId,
  detailRouteId: (contract.detailRouteId ?? contract.listRouteId) as RouteId,
  readOperationId: contract.readOperationId as OperationId,
};
